"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AuthException_1 = __importDefault(require("../Exception/AuthException"));
class TokenService {
    constructor(auth, authCache, dateTimeProvider) {
        this.isRefreshing = false;
        this.getValidToken = async () => {
            try {
                const authData = await this.authCache.getAuthData();
                if (!this.shouldRefresh(authData)) {
                    return authData.token;
                }
                return this.refresh(authData.refreshToken);
            }
            catch (e) {
                if (!(e instanceof AuthException_1.default)) {
                    throw e;
                }
                throw new AuthException_1.default(e);
            }
        };
        this.setNew = (tokenData) => {
            return this.authCache.setAuthData(tokenData !== null
                ? {
                    token: tokenData.token,
                    refreshToken: tokenData.refreshToken,
                    expiresIn: this.dateTimeProvider.currentTimestamp() +
                        tokenData.expiresIn -
                        60,
                }
                : null);
        };
        this.unset = () => {
            return this.authCache.unset();
        };
        this.shouldRefresh = (authData) => {
            return authData.expiresIn <= this.dateTimeProvider.currentTimestamp();
        };
        this.refresh = async (refreshToken) => {
            if (this.isRefreshing) {
                return this.refreshPromise;
            }
            this.isRefreshing = true;
            this.refreshPromise = new Promise(async (resolve, reject) => {
                try {
                    const response = await this.auth.refreshToken(refreshToken);
                    await this.setNew({
                        token: response.token,
                        refreshToken: response.refreshToken,
                        expiresIn: response.expiresIn,
                    });
                    this.isRefreshing = false;
                    resolve(response.token);
                }
                catch (e) {
                    this.isRefreshing = false;
                    reject(e);
                }
            });
            return this.refreshPromise;
        };
        this.authCache = authCache;
        this.dateTimeProvider = dateTimeProvider;
        this.auth = auth;
    }
}
exports.default = TokenService;
//# sourceMappingURL=TokenService.js.map